import React, { useState, useEffect, useRef } from 'react';
import { IoTimeOutline } from 'react-icons/io5';
import { format, addDays, isSameDay } from 'date-fns';

const QuickPicks = ({ onSelect }) => {
    const quickPicks = [
        {
            label: "Tomorrow 9:00 AM",
            getDate: () => {
                const date = new Date();
                date.setDate(date.getDate() + 1);
                date.setHours(9, 0, 0, 0);
                return date;
            }
        },
        {
            label: "Monday 9:00 AM",
            getDate: () => {
                const date = new Date();
                const day = date.getDay();
                const daysUntilMonday = (1 + 7 - day) % 7 || 7;
                date.setDate(date.getDate() + daysUntilMonday);
                date.setHours(9, 0, 0, 0);
                return date;
            }
        },
        {
            label: "Tonight 6:00 PM",
            getDate: () => {
                const date = new Date();
                const hour = date.getHours();
                if (hour >= 18) {
                    date.setDate(date.getDate() + 1);
                }
                date.setHours(18, 0, 0, 0);
                return date;
            }
        }
    ];

    return (
        <div className="space-y-2">
            <div className="text-xs font-medium text-gray-500 mb-2">Quick Schedule</div>
            <div className="flex flex-wrap gap-2">
                {quickPicks.map((pick) => (
                    <button
                        key={pick.label}
                        onClick={() => onSelect(pick.getDate())}
                        className="bg-indigo-50 text-indigo-600 hover:bg-indigo-100 rounded-lg py-2 px-3 text-sm font-medium transition-colors"
                    >
                        {pick.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default QuickPicks;
